import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {GAME_STATE} from "utils";
import {upsertIpxWorldHistory} from "api-v3";
import View from "./View";

export default function Container() {
  const dispatch = useDispatch();
  const {gameState} = useSelector(state => state.game);

  useEffect(() => {
    const enterRunnerz = async () => {
      try {
        await upsertIpxWorldHistory({worldType: "RUNNERZ", isInit: true});
      } catch (error) {
        console.log(error);
      }
    };

    enterRunnerz();
  }, []);

  useEffect(() => {
    if (gameState === GAME_STATE.ENDED) {
      const joystick = document.querySelector("#joystick");
      const jumpButton = document.querySelector("#joystick_button_J");

      if (joystick) {
        joystick.remove();
      }

      if (jumpButton) {
        jumpButton.remove();
      }
    }
  }, [gameState]);

  return <View gameState={gameState} />;
}
